export default "__VITE_ASSET__9HH66L8e__"